/**
 * 主界面中心组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>	
		<div class="row J_mainContent" id="content-main">
			<router-view name="cntBody"></router-view>
		</div>
		
</template>

<script>
import ContentTab from './ContentTab'
	export default {
		name: 'ContentBody',
		components: {
			ContentTab
		},
		data() {
			return {

			};
		}
	};
</script>


// WEBPACK FOOTER //
// ContentBody.vue?66d446f3